import jsPDF from 'jspdf';

export const generatePurchaseOrderPDF = (po, logoBase64) => {
  const pdf = new jsPDF();
  const pageWidth = 210;
  const margin = 15;
  let y = 15;
  const isImport = po.type === 'import';
  const currency = po.currency || 'INR';
  const currSym = currency === 'INR' ? 'INR' : currency;

  // Company Header / Letterhead
  pdf.setFillColor(36, 84, 156);
  pdf.rect(0, 0, pageWidth, 38, 'F');
  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(18);
  pdf.setFont(undefined, 'bold');
  pdf.text('SHARDA INFRASOLUTIONS PVT. LTD.', margin, 15);
  pdf.setFontSize(8);
  pdf.setFont(undefined, 'normal');
  pdf.text('Road Safety & Infrastructure Solutions', margin, 22);
  pdf.text('CIN: U24100JH2010PTC014546 | PAN: AAPCS1562H', margin, 28);
  pdf.text('www.prismoline.com | info@prismoline.com | +91 7033275747', margin, 34);

  if (logoBase64) {
    try { pdf.addImage(logoBase64, 'PNG', pageWidth - margin - 57, 2, 57, 32); } catch (e) { /* logo failed silently */ }
  }

  y = 45;
  pdf.setTextColor(36, 84, 156);
  pdf.setFontSize(14);
  pdf.setFont(undefined, 'bold');
  pdf.text('PURCHASE ORDER', pageWidth / 2, y, { align: 'center' });

  y = 52;
  pdf.setDrawColor(36, 84, 156);
  pdf.line(margin, y, pageWidth - margin, y);
  y += 5;

  pdf.setTextColor(100, 100, 100);
  pdf.setFontSize(8);
  pdf.setFont(undefined, 'normal');

  const leftCol = margin;
  const rightCol = pageWidth / 2 + 5;
  const leftVal = leftCol + 32;
  const rightVal = rightCol + 32;

  pdf.text('PO Number:', leftCol, y);
  pdf.setTextColor(0); pdf.setFont(undefined, 'bold');
  pdf.text(po.po_number || po.id?.substring(0, 12), leftVal, y);

  pdf.setTextColor(100, 100, 100); pdf.setFont(undefined, 'normal');
  pdf.text('Date:', rightCol, y);
  pdf.setTextColor(0); pdf.setFont(undefined, 'bold');
  pdf.text(po.date || '', rightVal, y);

  y += 6;
  pdf.setTextColor(100, 100, 100); pdf.setFont(undefined, 'normal');
  pdf.text('Reference No:', leftCol, y);
  pdf.setTextColor(0); pdf.text(po.reference_no || '-', leftVal, y);

  pdf.setTextColor(100, 100, 100);
  pdf.text('Delivery Date:', rightCol, y);
  pdf.setTextColor(0); pdf.text(po.expected_delivery || '', rightVal, y);

  y += 6;
  pdf.setTextColor(100, 100, 100);
  pdf.text('Type:', leftCol, y);
  pdf.setTextColor(0); pdf.text((po.type || '').toUpperCase(), leftVal, y);

  pdf.setTextColor(100, 100, 100);
  pdf.text('Currency:', rightCol, y);
  pdf.setTextColor(0); pdf.text(currency, rightVal, y);

  if (po.vendor_pi) {
    y += 6;
    pdf.setTextColor(100, 100, 100); pdf.setFont(undefined, 'normal');
    pdf.text('Vendor PI:', leftCol, y);
    pdf.setTextColor(0); pdf.setFont(undefined, 'bold');
    pdf.text(po.vendor_pi, leftVal, y);
  }

  // Vendor & Address Section
  y += 10;

  // Calculate vendor address height first
  let vendorAddr = po.vendor_address || '';
  if (po.vendor_city && !vendorAddr.includes(po.vendor_city)) vendorAddr += (vendorAddr ? ', ' : '') + po.vendor_city;
  if (po.vendor_state && !vendorAddr.includes(po.vendor_state)) vendorAddr += (vendorAddr ? ', ' : '') + po.vendor_state;
  const leftBoxW = (pageWidth - 2 * margin) / 2 - 3;
  pdf.setFont(undefined, 'normal'); pdf.setFontSize(8);
  const vendorNameLines = pdf.splitTextToSize(po.vendor_name || '', leftBoxW - 6);
  pdf.setFontSize(7);
  const wrappedVendorLines = vendorAddr ? pdf.splitTextToSize(vendorAddr, leftBoxW - 6) : [];
  const vendorContentH = 18 + wrappedVendorLines.length * 3.5 + (vendorNameLines.length - 1) * 4;

  // Calculate billing address height
  const billText = po.billing_address || '';
  const billLines = billText.split('\n').filter(line => !line.toLowerCase().startsWith('gstin'));
  const billContentH = 17 + billLines.length * 4;

  const boxHeight = Math.max(vendorContentH, billContentH, 30) + 4;

  pdf.setFillColor(245, 247, 250);
  pdf.rect(margin, y - 3, leftBoxW, boxHeight, 'F');
  pdf.rect(pageWidth / 2 + 2, y - 3, (pageWidth - 2 * margin) / 2 - 3, boxHeight, 'F');

  pdf.setTextColor(36, 84, 156); pdf.setFont(undefined, 'bold'); pdf.setFontSize(7);
  pdf.text('VENDOR DETAILS', leftCol + 2, y + 2);
  pdf.setTextColor(0); pdf.setFont(undefined, 'normal'); pdf.setFontSize(8);
  vendorNameLines.forEach((line, i) => pdf.text(line, leftCol + 2, y + 8 + i * 4));
  pdf.setFontSize(7);
  let vendorY = y + 13 + (vendorNameLines.length - 1) * 4;
  if (wrappedVendorLines.length > 0) {
    wrappedVendorLines.forEach((line, i) => { pdf.text(line, leftCol + 2, vendorY + (i * 3.5)); });
    vendorY += wrappedVendorLines.length * 3.5;
  }
  pdf.text(`GSTIN: ${po.vendor_gst || '-'}`, leftCol + 2, vendorY);

  pdf.setTextColor(36, 84, 156); pdf.setFont(undefined, 'bold'); pdf.setFontSize(7);
  pdf.text('BILLING ADDRESS', rightCol, y + 2);
  pdf.setTextColor(0); pdf.setFont(undefined, 'bold'); pdf.setFontSize(8);
  pdf.text('Sharda Infrasolutions Pvt Ltd', rightCol, y + 7);
  pdf.setFont(undefined, 'normal'); pdf.setFontSize(7);
  billLines.forEach((line, i) => { pdf.text(line, rightCol, y + 12 + (i * 4)); });
  if (po.company_gst) {
    pdf.text(`GSTIN: ${po.company_gst}`, rightCol, y + 12 + billLines.length * 4);
  }

  y += boxHeight + 4;

  // Ship To Address — dynamic height
  if (po.shipping_address) {
    pdf.setTextColor(36, 84, 156); pdf.setFont(undefined, 'bold'); pdf.setFontSize(7);
    pdf.text('SHIP TO ADDRESS', leftCol, y);
    pdf.setTextColor(0); pdf.setFont(undefined, 'normal');
    const shipLines = pdf.splitTextToSize(po.shipping_address, pageWidth - 2 * margin);
    shipLines.forEach((line, i) => { pdf.text(line, leftCol, y + 5 + (i * 4)); });
    y += 7 + shipLines.length * 4;
  }

  // Items Table — with clear gap
  y += 6;
  pdf.setFillColor(36, 84, 156);
  pdf.rect(margin, y, pageWidth - 2 * margin, 7, 'F');
  pdf.setTextColor(255); pdf.setFont(undefined, 'bold'); pdf.setFontSize(7);

  if (isImport) {
    // No GST column for import
    const cols = [margin + 2, margin + 10, margin + 75, margin + 95, margin + 115, margin + 155];
    pdf.text('#', cols[0], y + 5);
    pdf.text('Item', cols[1], y + 5);
    pdf.text('HSN', cols[2], y + 5);
    pdf.text('Qty', cols[3], y + 5);
    pdf.text(`Rate (${currSym})`, cols[4], y + 5);
    pdf.text(`Amount (${currSym})`, cols[5], y + 5);

    y += 10;
    pdf.setTextColor(0); pdf.setFont(undefined, 'normal'); pdf.setFontSize(8);
    let subtotal = 0;
    const tableX = margin;
    const tableW = pageWidth - 2 * margin;
    (po.items || []).forEach((item, idx) => {
      const amt = item.amount || item.qty * item.rate;
      subtotal += amt;
      pdf.setFontSize(8);
      const nameLines = pdf.splitTextToSize(item.name || '', cols[2] - cols[1] - 3);
      pdf.setFontSize(6.5);
      const descLines = item.description ? pdf.splitTextToSize(`Description:- ${item.description}`, tableX + tableW - cols[1] - 4) : [];
      pdf.setFontSize(8);
      const rowH = nameLines.length * 4 + (descLines.length ? descLines.length * 3 + 2 : 2) + 1;
      if (idx % 2 === 0) { pdf.setFillColor(248, 249, 252); pdf.rect(tableX, y - 4, tableW, rowH, 'F'); }
      pdf.setTextColor(0);
      pdf.text(`${idx + 1}`, cols[0], y);
      nameLines.forEach((l, i) => pdf.text(l, cols[1], y + i * 4));
      pdf.text(item.hsn_code || '-', cols[2], y);
      pdf.text(`${item.qty} ${item.unit}`, cols[3], y);
      pdf.text(`${(item.rate || 0).toLocaleString('en-IN')}`, cols[4], y);
      pdf.text(`${amt.toLocaleString('en-IN')}`, cols[5], y);
      y += nameLines.length * 4 + 1;
      if (descLines.length) {
        pdf.setFontSize(6.5); pdf.setTextColor(100);
        descLines.forEach((l, i) => pdf.text(l, cols[1], y + i * 3));
        pdf.setFontSize(8); pdf.setTextColor(0);
        y += descLines.length * 3 + 2;
      } else {
        y += 2;
      }
      pdf.setDrawColor(220); pdf.line(tableX, y, tableX + tableW, y);
      if (y > 260) { pdf.addPage(); y = 15; }
    });

    y += 3;
    pdf.setDrawColor(36, 84, 156); pdf.setLineWidth(0.5); pdf.line(margin, y, pageWidth - margin, y); pdf.setLineWidth(0.2);
    y += 6;

    pdf.setFontSize(8);
    pdf.text(`Total (${currSym}):`, cols[4] - 5, y); pdf.setFont(undefined, 'bold');
    pdf.text(`${currSym} ${subtotal.toLocaleString('en-IN')}`, cols[5], y);

    if (currency !== 'INR' && po.exchange_rate) {
      y += 6;
      pdf.setFont(undefined, 'normal');
      pdf.text(`Exchange Rate:`, cols[4] - 5, y);
      pdf.text(`${po.exchange_rate} per ${currency}`, cols[5], y);
      y += 6;
      const inrTotal = Math.round(subtotal * po.exchange_rate);
      pdf.setFillColor(36, 84, 156);
      pdf.rect(cols[4] - 10, y - 4, pageWidth - margin - cols[4] + 10, 8, 'F');
      pdf.setTextColor(255); pdf.setFont(undefined, 'bold'); pdf.setFontSize(9);
      pdf.text('INR Equivalent:', cols[4] - 5, y + 1);
      pdf.text(`INR ${inrTotal.toLocaleString('en-IN')}`, cols[5], y + 1);
    } else {
      y += 6;
      pdf.setFillColor(36, 84, 156);
      pdf.rect(cols[4] - 10, y - 4, pageWidth - margin - cols[4] + 10, 8, 'F');
      pdf.setTextColor(255); pdf.setFont(undefined, 'bold'); pdf.setFontSize(9);
      pdf.text('Grand Total:', cols[4] - 5, y + 1);
      pdf.text(`${currSym} ${subtotal.toLocaleString('en-IN')}`, cols[5], y + 1);
    }
  } else {
    // Domestic — with GST
    const cols = [margin + 2, margin + 10, margin + 70, margin + 90, margin + 108, margin + 130, margin + 155];
    const colHeaders = ['#', 'Item', 'HSN', 'Qty', 'Rate', 'GST %', 'Amount'];
    colHeaders.forEach((h, i) => pdf.text(h, cols[i], y + 5));

    y += 10;
    pdf.setTextColor(0); pdf.setFont(undefined, 'normal'); pdf.setFontSize(8);
    let subtotal = 0;
    const tableX = margin;
    const tableW = pageWidth - 2 * margin;
    (po.items || []).forEach((item, idx) => {
      const amt = item.amount || item.qty * item.rate;
      subtotal += amt;
      pdf.setFontSize(8);
      const nameLines = pdf.splitTextToSize(item.name || '', cols[2] - cols[1] - 3);
      pdf.setFontSize(6.5);
      const descLines = item.description ? pdf.splitTextToSize(`Description:- ${item.description}`, tableX + tableW - cols[1] - 4) : [];
      pdf.setFontSize(8);
      const rowH = nameLines.length * 4 + (descLines.length ? descLines.length * 3 + 2 : 2) + 1;
      // Alternate row background
      if (idx % 2 === 0) { pdf.setFillColor(248, 249, 252); pdf.rect(tableX, y - 4, tableW, rowH, 'F'); }
      pdf.setTextColor(0);
      pdf.text(`${idx + 1}`, cols[0], y);
      nameLines.forEach((l, i) => pdf.text(l, cols[1], y + i * 4));
      pdf.text(item.hsn_code || '-', cols[2], y);
      pdf.text(`${item.qty} ${item.unit}`, cols[3], y);
      pdf.text(`${(item.rate || 0).toLocaleString('en-IN')}`, cols[4], y);
      pdf.text(`${item.gst_rate || 18}%`, cols[5], y);
      pdf.text(`${amt.toLocaleString('en-IN')}`, cols[6], y);
      y += nameLines.length * 4 + 1;
      if (descLines.length) {
        pdf.setFontSize(6.5); pdf.setTextColor(100);
        descLines.forEach((l, i) => pdf.text(l, cols[1], y + i * 3));
        pdf.setFontSize(8); pdf.setTextColor(0);
        y += descLines.length * 3 + 2;
      } else {
        y += 2;
      }
      // Row separator line
      pdf.setDrawColor(220); pdf.line(tableX, y, tableX + tableW, y);
      if (y > 260) { pdf.addPage(); y = 15; }
    });

    y += 3;
    pdf.setDrawColor(36, 84, 156); pdf.setLineWidth(0.5); pdf.line(margin, y, pageWidth - margin, y); pdf.setLineWidth(0.2);
    y += 6;

    // Calculate GST per-item using each item's gst_rate
    const itemsGST = (po.items || []).reduce((sum, item) => {
      const rate = item.gst_rate ?? 18;
      return sum + (item.amount || item.qty * item.rate || 0) * (rate / 100);
    }, 0);
    const taxableCharges = (po.other_charges || []).filter(c => c.taxable).reduce((s, c) => s + (c.amount || 0), 0);
    const nonTaxableCharges = (po.other_charges || []).filter(c => !c.taxable).reduce((s, c) => s + (c.amount || 0), 0);
    // Weighted avg GST rate for taxable other charges
    const weightedAvgRate = subtotal > 0
      ? (po.items || []).reduce((s, i) => s + (i.amount || 0) * ((i.gst_rate ?? 18) / 100), 0) / subtotal * 100
      : 18;
    const chargesGST = taxableCharges * (weightedAvgRate / 100);
    const gstAmt = itemsGST + chargesGST;
    const grandTotal = subtotal + taxableCharges + nonTaxableCharges + gstAmt;
    // Dynamic GST label
    const gstRates = [...new Set((po.items || []).map(i => i.gst_rate ?? 18))];
    const gstLabel = gstRates.length === 1 ? `GST (${gstRates[0]}%)` : 'GST (Mixed Rates)';

    pdf.setFontSize(8);
    pdf.text('Subtotal:', cols[5] - 15, y); pdf.setFont(undefined, 'bold');
    pdf.text(`INR ${subtotal.toLocaleString('en-IN')}`, cols[6], y);

    // Show extra charges in PDF
    if ((po.other_charges || []).length > 0) {
      (po.other_charges || []).forEach(charge => {
        y += 5;
        pdf.setFont(undefined, 'normal');
        const chargeLabel = `${charge.description || 'Other Charge'}${charge.taxable ? ' (+GST)' : ''}:`;
        pdf.text(chargeLabel, cols[5] - 15, y);
        pdf.text(`INR ${(charge.amount || 0).toLocaleString('en-IN')}`, cols[6], y);
      });
    }

    y += 6;
    pdf.setFont(undefined, 'normal');
    pdf.text(`${gstLabel}:`, cols[5] - 15, y);
    pdf.text(`INR ${Math.round(gstAmt).toLocaleString('en-IN')}`, cols[6], y);
    y += 6;
    pdf.setFillColor(36, 84, 156);
    pdf.rect(cols[4], y - 4, pageWidth - margin - cols[4], 8, 'F');
    pdf.setTextColor(255); pdf.setFont(undefined, 'bold'); pdf.setFontSize(9);
    pdf.text('Grand Total:', cols[5] - 15, y + 1);
    pdf.text(`INR ${Math.round(grandTotal).toLocaleString('en-IN')}`, cols[6], y + 1);
  }

  y += 14;
  pdf.setTextColor(0); pdf.setFont(undefined, 'normal'); pdf.setFontSize(7);

  // Import/Shipping Details section for import POs
  if (isImport) {
    const shippingFields = [
      { label: 'Loading Port', value: po.loading_port },
      { label: 'Discharge Port', value: po.discharge_port },
      { label: 'Dispatch By', value: po.dispatch_by },
      { label: 'Incoterms', value: po.incoterms },
      { label: 'ETD', value: po.etd },
      { label: 'ETA', value: po.eta },
      { label: 'Shipping Line', value: po.shipping_line },
      { label: 'BL / AWB', value: po.bl_awb_number },
    ].filter(f => f.value && f.value !== 'None');

    if (shippingFields.length > 0) {
      if (y > 250) { pdf.addPage(); y = 15; }
      pdf.setFillColor(240, 245, 255);
      const shippingBoxH = Math.ceil(shippingFields.length / 4) * 12 + 10;
      pdf.rect(margin, y - 2, pageWidth - 2 * margin, shippingBoxH, 'F');
      pdf.setDrawColor(36, 84, 156); pdf.setLineWidth(0.3);
      pdf.rect(margin, y - 2, pageWidth - 2 * margin, shippingBoxH, 'S');
      pdf.setLineWidth(0.2);

      pdf.setTextColor(36, 84, 156); pdf.setFont(undefined, 'bold'); pdf.setFontSize(7);
      pdf.text('IMPORT / SHIPPING DETAILS', margin + 3, y + 3);
      let sy = y + 8;
      pdf.setFontSize(7);
      const colW = (pageWidth - 2 * margin - 6) / 4;
      shippingFields.forEach((f, i) => {
        const col = i % 4;
        const row = Math.floor(i / 4);
        const sx = margin + 3 + col * colW;
        const ssy = sy + row * 12;
        pdf.setTextColor(100); pdf.setFont(undefined, 'normal');
        pdf.text(f.label + ':', sx, ssy);
        pdf.setTextColor(0); pdf.setFont(undefined, 'bold');
        pdf.text(String(f.value), sx, ssy + 4);
      });
      y += shippingBoxH + 4;
    }
  }

  if (po.payment_terms) { pdf.setFont(undefined, 'bold'); pdf.text('Payment Terms: ', margin, y); pdf.setFont(undefined, 'normal'); pdf.text(po.payment_terms, margin + 28, y); y += 5; }
  if (po.delivery_terms) { pdf.setFont(undefined, 'bold'); pdf.text('Delivery Terms: ', margin, y); pdf.setFont(undefined, 'normal'); pdf.text(po.delivery_terms, margin + 28, y); y += 5; }
  if (po.comments) { pdf.setFont(undefined, 'bold'); pdf.text('Comments: ', margin, y); pdf.setFont(undefined, 'normal'); const commentLines = pdf.splitTextToSize(po.comments, 150); commentLines.forEach(line => { pdf.text(line, margin + 22, y); y += 4; }); y += 1; }

  y = 275;
  pdf.setDrawColor(36, 84, 156); pdf.line(margin, y, pageWidth - margin, y);
  y += 4;
  pdf.setFontSize(7); pdf.setTextColor(120);
  pdf.text('This is a system-generated Purchase Order from Prismoline ERP.', pageWidth / 2, y, { align: 'center' });

  pdf.save(`PO_${po.po_number || po.id?.substring(0, 8)}.pdf`);
};

export const printPurchaseOrder = (po) => {
  const isImport = po.type === 'import';
  const currency = po.currency || 'INR';
  const currSym = currency === 'INR' ? '₹' : currency;
  const itemsSubtotal = (po.items || []).reduce((s, i) => s + (i.amount || 0), 0);

  let totalsHtml = '';
  if (isImport) {
    totalsHtml = `
      <div class="total-row">Total: <strong>${currSym} ${itemsSubtotal.toLocaleString('en-IN')}</strong></div>
      ${currency !== 'INR' && po.exchange_rate ? `<div class="total-row" style="font-size:10px;color:#666">Exchange Rate: ${po.exchange_rate} per ${currency}</div>
      <div class="total-row" style="background:#24549c;color:#fff;padding:8px;border-radius:4px;font-size:14px">INR Equivalent: <strong>INR ${Math.round(itemsSubtotal * (po.exchange_rate || 1)).toLocaleString('en-IN')}</strong></div>` :
      `<div class="total-row" style="background:#24549c;color:#fff;padding:8px;border-radius:4px;font-size:14px">Grand Total: <strong>${currSym} ${itemsSubtotal.toLocaleString('en-IN')}</strong></div>`}
    `;
  } else {
    const taxableChargesTotal = (po.other_charges || []).filter(c => c.taxable).reduce((s, c) => s + (c.amount || 0), 0);
    const nonTaxableChargesTotal = (po.other_charges || []).filter(c => !c.taxable).reduce((s, c) => s + (c.amount || 0), 0);
    // Per-item GST calculation
    const perItemGST = (po.items || []).reduce((sum, item) => sum + (item.amount || 0) * ((item.gst_rate ?? 18) / 100), 0);
    const weightedAvgRate = itemsSubtotal > 0
      ? (po.items || []).reduce((s, i) => s + (i.amount || 0) * ((i.gst_rate ?? 18) / 100), 0) / itemsSubtotal * 100
      : 18;
    const chargesGST = taxableChargesTotal * (weightedAvgRate / 100);
    const gst = perItemGST + chargesGST;
    const grand = itemsSubtotal + taxableChargesTotal + nonTaxableChargesTotal + gst;
    const gstRatesArr = [...new Set((po.items || []).map(i => i.gst_rate ?? 18))];
    const gstLabelStr = gstRatesArr.length === 1 ? `GST (${gstRatesArr[0]}%)` : 'GST (Mixed Rates)';
    let chargesHtml = '';
    (po.other_charges || []).forEach(c => {
      chargesHtml += `<div class="total-row">${c.description || 'Other Charge'}${c.taxable ? ' (+GST)' : ''}: <strong>INR ${(c.amount || 0).toLocaleString('en-IN')}</strong></div>`;
    });
    totalsHtml = `
      <div class="total-row">Subtotal: <strong>INR ${itemsSubtotal.toLocaleString('en-IN')}</strong></div>
      ${chargesHtml}
      <div class="total-row">${gstLabelStr}: <strong>INR ${Math.round(gst).toLocaleString('en-IN')}</strong></div>
      <div class="total-row" style="background:#24549c;color:#fff;padding:8px;border-radius:4px;font-size:14px">Grand Total: <strong>INR ${Math.round(grand).toLocaleString('en-IN')}</strong></div>
    `;
  }

  const gstHeader = isImport ? '' : '<th>GST</th>';
  const itemRows = (po.items || []).map((item, i) => {
    const gstCol = isImport ? '' : `<td>${item.gst_rate || 18}%</td>`;
    const descLine = item.description ? `<br><span style="font-size:9px;color:#666">Description:- ${item.description}</span>` : '';
    return `<tr><td>${i + 1}</td><td>${item.name}${descLine}</td><td>${item.hsn_code || '-'}</td><td>${item.qty} ${item.unit}</td><td>${currSym} ${(item.rate || 0).toLocaleString('en-IN')}</td>${gstCol}<td>${currSym} ${(item.amount || 0).toLocaleString('en-IN')}</td></tr>`;
  }).join('');

  const w = window.open('', '_blank');
  w.document.write(`<!DOCTYPE html><html><head><title>PO - ${po.po_number || po.id}</title><style>
    *{margin:0;padding:0;box-sizing:border-box} body{font-family:'Segoe UI',sans-serif;padding:20px;color:#1a1a1a;font-size:12px}
    .header{background:#24549c;color:#fff;padding:20px;margin:-20px -20px 0;display:flex;justify-content:space-between;align-items:center} .header-left h1{font-size:18px;margin-bottom:4px} .header-left p{font-size:9px;opacity:0.85} .header-logo img{height:60px;width:auto}
    .po-title{text-align:center;font-size:16px;font-weight:700;color:#24549c;margin:15px 0;letter-spacing:1px}
    .info-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:15px} .info-box{background:#f5f7fa;padding:10px;border-radius:6px}
    .info-box h4{font-size:8px;color:#24549c;text-transform:uppercase;letter-spacing:1px;margin-bottom:4px}
    table{width:100%;border-collapse:collapse;margin:10px 0} th{background:#24549c;color:#fff;padding:6px 8px;font-size:9px;text-align:left}
    td{padding:6px 8px;border-bottom:1px solid #eee;font-size:11px} .total-row{text-align:right;font-size:12px;padding:6px 8px}
    .terms{margin-top:15px;font-size:10px;color:#555} .terms strong{color:#24549c} .footer{margin-top:20px;padding-top:10px;border-top:1px solid #24549c;text-align:center;color:#999;font-size:9px}
    @media print{body{padding:10px} .header{margin:-10px -10px 0}}
  </style></head><body>
    <div class="header"><div class="header-left"><h1>SHARDA INFRASOLUTIONS PVT. LTD.</h1><p>Road Safety & Infrastructure Solutions | CIN: U24100JH2010PTC014546 | PAN: AAPCS1562H | +91 7033275747 | www.prismoline.com</p></div><div class="header-logo"><img src="/prismoline-logo.png" alt="Logo" /></div></div>
    <div class="po-title">PURCHASE ORDER</div>
    <div class="info-grid">
      <div><strong>PO Number:</strong> ${po.po_number || po.id}<br><strong>Date:</strong> ${po.date}<br><strong>Ref:</strong> ${po.reference_no || '-'}${po.vendor_pi ? '<br><strong>Vendor PI:</strong> ' + po.vendor_pi : ''}<br><strong>Type:</strong> ${(po.type || '').toUpperCase()}</div>
      <div style="text-align:right"><strong>Delivery Date:</strong> ${po.expected_delivery}<br><strong>Currency:</strong> ${currency}<br><strong>Status:</strong> ${po.status}</div>
    </div>
    <div class="info-grid">
      <div class="info-box"><h4>Vendor</h4><strong>${po.vendor_name}</strong>${(() => { let a = po.vendor_address || ''; if (po.vendor_city && !a.includes(po.vendor_city)) a += (a ? ', ' : '') + po.vendor_city; if (po.vendor_state && !a.includes(po.vendor_state)) a += (a ? ', ' : '') + po.vendor_state; return a ? '<br>' + a.replace(/\n/g, '<br>') : ''; })()}<br>GSTIN: ${po.vendor_gst || '-'}</div>
      <div class="info-box"><h4>Bill To</h4><strong>Sharda Infrasolutions Pvt Ltd</strong><br>${((po.billing_address || '').split('\n').filter(l => !l.toLowerCase().startsWith('gstin')).join('\n')).replace(/\n/g, '<br>')}${po.company_gst ? '<br>GSTIN: ' + po.company_gst : ''}</div>
    </div>
    ${po.shipping_address ? `<div class="info-box" style="margin-bottom:10px"><h4>Ship To</h4>${po.shipping_address}</div>` : ''}
    ${isImport ? (() => {
      const sf = [
        { label: 'Loading Port', value: po.loading_port },
        { label: 'Discharge Port', value: po.discharge_port },
        { label: 'Dispatch By', value: po.dispatch_by },
        { label: 'Incoterms', value: po.incoterms },
        { label: 'ETD', value: po.etd },
        { label: 'ETA', value: po.eta },
        { label: 'Shipping Line', value: po.shipping_line },
        { label: 'BL / AWB', value: po.bl_awb_number },
      ].filter(f => f.value && f.value !== 'None');
      return sf.length > 0 ? `<div class="info-box" style="margin-bottom:10px;border:1px solid #cde;background:#f0f5ff"><h4>Import / Shipping Details</h4><div style="display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:8px">${sf.map(f => `<div><span style="font-size:8px;color:#666;text-transform:uppercase">${f.label}</span><br><strong style="font-size:11px">${f.value}</strong></div>`).join('')}</div></div>` : '';
    })() : ''}
    <table><thead><tr><th>#</th><th>Item</th><th>HSN</th><th>Qty</th><th>Rate</th>${gstHeader}<th>Amount</th></tr></thead><tbody>
      ${itemRows}
    </tbody></table>
    <div style="text-align:right;margin-top:10px">
      ${totalsHtml}
    </div>
    <div class="terms">${po.payment_terms ? `<p><strong>Payment Terms:</strong> ${po.payment_terms}</p>` : ''}${po.delivery_terms ? `<p><strong>Delivery Terms:</strong> ${po.delivery_terms}</p>` : ''}${po.comments ? `<p><strong>Comments:</strong> ${po.comments}</p>` : ''}</div>
    <div class="footer">This is a system-generated Purchase Order from Prismoline ERP.</div>
  </body></html>`);
  w.document.close();
  setTimeout(() => w.print(), 300);
};
